<div class="table-responsive">
    <table class="table table-sm table-hover table-bordered">
        <thead>
            <tr>
                <th class="text-center">{{'FullName' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of ticketResult">
                <td class="text-center">{{item.assignedEmployeeFullName}}</td>
            </tr>
        </tbody>
    </table>
</div>